import { render } from "./PopularUsersPost.vue?vue&type=template&id=3dd4b2e3&scoped=true&lang=pug"
import script from "./PopularUsersPost.vue?vue&type=script&lang=js"
export * from "./PopularUsersPost.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd4b2e3"]])

export default __exports__